import { useEffect, useRef } from 'react'
import deviceFingerprintService from '../services/deviceFingerprintService'

const useDeviceFingerprint = (enabled: boolean): React.RefObject<string | null> => {
  const fingerprintRef = useRef<string | null>(null)

  useEffect(() => {
    if (!enabled) return

    deviceFingerprintService.getFingerprint().then((id) => {
      fingerprintRef.current = id
    })
  }, [enabled])

  return fingerprintRef
}

export default useDeviceFingerprint
